import React, { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Loader2 } from 'lucide-react';

export const VerifyPage = () => {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const { verifyMagicLink, enableRememberDevice } = useAuth();
    const navigate = useNavigate();
    const [error, setError] = React.useState('');
    const verifyAttempted = useRef(false);

    useEffect(() => {
        const verify = async () => {
            // Prevent double verification in StrictMode
            if (verifyAttempted.current) return;
            verifyAttempted.current = true;
            
            if (!token) {
                navigate('/login');
                return;
            }

            const result = await verifyMagicLink(token);
            if (result.success) {
                // Check if user wanted to remember this device
                const shouldRemember = localStorage.getItem('remember_me_pending');
                if (shouldRemember) {
                    localStorage.removeItem('remember_me_pending');
                    await enableRememberDevice();
                }
                navigate('/my-library');
            } else {
                setError(result.error);
            }
        };

        verify();
    }, [token, verifyMagicLink, enableRememberDevice, navigate]);

    if (error) {
        return (
            <div className="min-h-[calc(100vh-64px)] flex items-center justify-center" data-testid="verify-page-error">
                <div className="text-center">
                    <h1 className="font-serif text-2xl font-medium mb-2">Verification Failed</h1>
                    <p className="text-muted-foreground mb-4">{error}</p>
                    <a href="/login" className="text-accent hover:underline">
                        Try again
                    </a>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-[calc(100vh-64px)] flex items-center justify-center" data-testid="verify-page">
            <div className="text-center">
                <Loader2 className="h-8 w-8 animate-spin text-accent mx-auto mb-4" />
                <h1 className="font-serif text-2xl font-medium">Verifying your link...</h1>
                <p className="text-muted-foreground mt-2">Please wait</p>
            </div>
        </div>
    );
};

export default VerifyPage;
